import { useLang } from "@/context/LangContext";
import { ShieldCheck, Award, Users } from "lucide-react";

export default function About() {
  const { t } = useLang();

  const points = [
    { icon: Award, title: t("about.point1.title"), body: t("about.point1.body") },
    { icon: ShieldCheck, title: t("about.point2.title"), body: t("about.point2.body") },
    { icon: Users, title: t("about.point3.title"), body: t("about.point3.body") },
  ];

  return (
    <section id="sobre" className="bg-[#F9F8F6] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F26419] mb-4">
              {t("about.kicker")}
            </p>
            <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tighter text-[#1A1B1A]">
              {t("about.title")}
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-[#5C635A] max-w-2xl">
              {t("about.body")}
            </p>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 gap-4">
            {points.map((p, i) => (
              <div
                key={i}
                className="bg-white border-2 border-[#1A1B1A] p-6 flex items-start gap-4 rv-shadow-hard"
              >
                <div className="w-12 h-12 bg-[#2D5A3C] flex items-center justify-center flex-shrink-0">
                  <p.icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-display font-bold text-lg text-[#1A1B1A]">{p.title}</h3>
                  <p className="text-sm text-[#5C635A] mt-1 leading-relaxed">{p.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
